import { jsx } from 'react/jsx-runtime';
import { useId } from '@radix-ui/react-id';
import { useLayoutEffect } from '@radix-ui/react-use-layout-effect';
import classNames from 'classnames';
import { forwardRef } from 'react';
import Label_Legacy from '../../../label/Label_Legacy.mjs';
import WhenValidGrandChildren from '../../../utility/WhenValidGrandChildren.mjs';
import useWithLabelProps from '../../hooks/useWithLabelProps.mjs';
import { baseLabel } from '../baseLabel.vanilla.mjs';
import { isSlotAvailable } from '../model.mjs';
import { useTextAreaContext } from './context.mjs';
import { styledLabel } from './label_legacy.vanilla.mjs';

const TEXT_AREA_LABEL_NAME = "TextAreaLabel";
const TextAreaLabel_Legacy = forwardRef(
  ({ id, ...props }, forwardedRef) => {
    const labelId = useId(id);
    const { size, required, disabled, state, setLabelledBy } = useTextAreaContext(TEXT_AREA_LABEL_NAME);
    useLayoutEffect(() => {
      setLabelledBy(labelId);
    }, [labelId, setLabelledBy]);
    const slotAvailable = isSlotAvailable(size);
    const restLabelProps = useWithLabelProps(props, size);
    const LabelImpl = slotAvailable ? Label_Legacy : StyledLabel;
    return /* @__PURE__ */ jsx(WhenValidGrandChildren, { children: /* @__PURE__ */ jsx(
      LabelImpl,
      {
        ...restLabelProps,
        id: labelId,
        disabled,
        state,
        size,
        required,
        ref: forwardedRef
      }
    ) });
  }
);
const StyledLabel = forwardRef(
  ({
    className: classNameFromProps,
    disabled,
    required,
    state,
    size,
    ...props
  }, forwardedRef) => {
    return /* @__PURE__ */ jsx(
      "span",
      {
        className: classNames(
          baseLabel({ disabled, required, state }),
          styledLabel({ size }),
          classNameFromProps
        ),
        ref: forwardedRef,
        ...props
      }
    );
  }
);

export { TextAreaLabel_Legacy as default };
//# sourceMappingURL=Label_Legacy.mjs.map
